import React, { createContext, useContext, useReducer } from 'react';

const PlannerContext = createContext();

const initialState = {
  assessmentType: '',
  students: [],
  groupSettings: {
    numberOfGroups: 3,
    sessionMinutes: 20,
    specialConsiderations: ''
  },
  groups: [],
  plan: null
};

function plannerReducer(state, action) {
  switch (action.type) {
    case 'SET_ASSESSMENT_TYPE':
      return { ...state, assessmentType: action.payload };
    case 'SET_STUDENTS':
      return { ...state, students: action.payload };
    case 'SET_GROUP_SETTINGS':
      return { ...state, groupSettings: { ...state.groupSettings, ...action.payload } };
    case 'SET_GROUPS':
      return { ...state, groups: action.payload };
    case 'SET_PLAN':
      return { ...state, plan: action.payload };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
}

export function PlannerProvider({ children }) {
  const [state, dispatch] = useReducer(plannerReducer, initialState);

  return (
    <PlannerContext.Provider value={{ state, dispatch }}>
      {children}
    </PlannerContext.Provider>
  );
}

export function usePlanner() {
  const context = useContext(PlannerContext);
  if (!context) {
    throw new Error('usePlanner must be used within a PlannerProvider');
  }
  return context;
}